export default {
  "languages": {
    "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
    "es": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Español"])},
    "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italiano"])}
  },
  "labels": {
    "language": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language"])}
  }
}